import { Box, List, ListItem, Menu, MenuButton, MenuItem, MenuList, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Col,Form,Row} from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import {  FaPen, FaPlusCircle } from "react-icons/fa";
import {  FaEllipsisVertical } from "react-icons/fa6";
import { IoIosClose } from "react-icons/io";
import VendorCustomSelect from "../Vendors/VendorCustomSelect";
import { taxOptions } from "../PurchaseItem/selectedOptions";
import { useDispatch, useSelector } from "react-redux";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { fetchAsyncGetOrganization } from "redux/organizationSlice";
import CustomPopover from "components/customPopover/customPopover";
import { PiExportBold } from "react-icons/pi";
import ItemCodePopover from "../PurchaseOrder/updatetemCodePopover";
import { calculateGstAmount, calculateTotalQuantityAndAmount } from "../PurchaseOrder/helperFunction";
import { fetchAsyncGetClientByID } from "redux/clientProjectSlice";
import AddSalesItemForm from "../SalesItem/addSalesItemForm";
import SalesInvoicePdf from "./ExportSalesOrder/salesInvoicePdf";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetSalesItemByClient } from "redux/salesItemSlice";
import { IoCloseCircleOutline } from "react-icons/io5";
import AmountInputField from "../component/amountField";
import InputFormControl from "../component/inputFormControl";
import CheckboxField from "../component/checkboxField";
import TextAreaField from "../component/textAreaField";
import { fetchAsyncGetSalesItemById } from "redux/salesItemSlice";

const AddItemComponent = ({
  itemList,
  handleListItem,
  handleAddRow,
  handleDeleteRow,
  handleRemoveSelectedItem,
  handleUpdateList,
  handleUpdateItemField,
  clientValue,
  getData,
  handleItemAmount,
  gstRecords,
  handleAdjustmentAmount,
  adjustmentAmount,
  handleShippingCharge,
  shippingCharge,
  editData,
  handleIsFright,
  isFright,
  totalPaymentAmount,
  currency,
  termsValue,
  invSubject,
  customerNotes,
  moduleId,
  adjustmentLabel,
  clientOption,
  handleAdjustmentLabel
})=>{

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuIndex, setMenuIndex] = useState("");
  const [openAddItem, setOpenAddItem] = useState(false);
  const [itemListData, setItemListData] = useState([]);
  const dispatch = useDispatch();
  const [openlistEditModal,setOpenEditModal] = useState(false)
  const [editListItem,setEditListItem] =  useState({})
  const [editListItemIndex,setEditListItemIndex] =  useState("")
  const [itemData, setItemData] = useState([])
  const [companyTypeValue, setCompanyTypeValue] = useState({});
  const { addToast } = useToasts();
  const [isSalesItemDataLoading, setIsSalesItemDataLoading]= useState(false);

  const [openMenu, setOpenMenu] = useState(false)

  const [gstType, setGstType] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [allGst,setAllGst] = useState([])


  const [gstAmount , setGstAmount] = useState({
    c:'',
    s:'',
    i:''
  })

  const organizationList = useSelector((state) => state.organizationData);

  const [total,setTotal] = useState({
    qty:0,
    amt:0,
    gstAmt:0,
  })



  useEffect(()=>{
    if(itemList && itemList?.length){
      setItemData(itemList)
      const totalGstAmount = currency?.code === 'INR' ? calculateGstAmount(itemList) : 0
      const totalValue = calculateTotalQuantityAndAmount(itemList);

      setTotal({
        ...total,
        qty:totalValue?.qty,
        amt: totalValue?.amt,
        gstAmt:totalGstAmount
      })
      let newGstAmount = { c: 0, s: 0, i: 0 };

      if (gstType === "CGST" || gstType === "SGST") {
        newGstAmount.c = totalGstAmount / 2;
        newGstAmount.s = totalGstAmount / 2;
        newGstAmount.i = 0; 
      } else if (gstType === "IGST") {
        newGstAmount.i = totalGstAmount;
        newGstAmount.c = 0; 
        newGstAmount.s = 0; 
      }

      setGstAmount(newGstAmount);
        if((newGstAmount.i) || (newGstAmount?.s && newGstAmount?.c)){
          const data = {
            bsAmt: Number(totalValue?.amt) + Number(totalGstAmount),
            cId: companyTypeValue,
            gstNo:gstNumber,
            prc:"",
            amt: newGstAmount
          };
          getData(data)
        }
      
      const totalAmt = Number(totalValue?.amt) + Number(adjustmentAmount || 0) + Number(shippingCharge || 0) + Number(total?.gstAmt || 0);
      const taxable = Number(totalValue?.amt);
      const requested = Number(totalValue?.amt) + Number(total?.gstAmt || 0);

      handleItemAmount({totalAmt,taxable,requested})

    }
    else{
      setItemData([])

    }
  },[itemList,gstType,gstNumber,adjustmentAmount,shippingCharge,total.gstAmt,currency])
  
  const handleFocus = (i) => {
    if(!currency?.code){
      addToast("Please Select Invoice Currency!", { appearance: "info" });
      return;
    }
    setIsMenuOpen(true);
    setMenuIndex(i)
  };

  const handleBlur = () => {
      setIsMenuOpen(false);
      setMenuIndex("")
  };
  const handleOpenAddItem = ()=>{
    setOpenAddItem(!openAddItem)
    handleBlur()
  }
  const handleCloseAddItem = ()=>{
    setOpenAddItem(!openAddItem)
    getSalesItemByClient()    
    setOpenEditModal(false);
    setEditListItem({});
    setEditListItemIndex("")

  }

  const handleEditListItem = async (item,index)=>{
    setIsSalesItemDataLoading(true);
    setOpenEditModal(true);
    const {dc, cId, ...itemWithoutClientAndDescription} = item || {};
    let itemToShow;
    try {
      const originalItem = item?._id && await fetchAsyncGetSalesItemById(item._id);
      itemToShow = originalItem?.item || itemWithoutClientAndDescription;
    } catch (error) {
      itemToShow = itemWithoutClientAndDescription;
      console.error(error);
    } finally {
      setIsSalesItemDataLoading(false);
    }
    const selectedClient = itemToShow?.cId && clientOption?.find?.(c => c.value === itemToShow.cId);
    setEditListItem({
      ...itemToShow,
      cId: selectedClient && {clName: selectedClient.label, _id: selectedClient.value},
    });
    setEditListItemIndex(index)
    handleOpenAddItem()

  }

  const getCompanyByID = async(id)=>{
    await dispatch(fetchAsyncGetClientByID(id)).then((res)=>{

    if(res?.payload){
      const client = res?.payload?.client;
      const setData = {
        label: client.clName,
        value: client?._id,
      };
      setCompanyTypeValue(setData);
      if (client?.gsts && client?.gsts?.length) {
        const gstNumbers = client?.gsts.map(gst => gst.gstNo); 
        setAllGst(gstNumbers); 
        if(!gstNumber && !gstRecords?.length){
          setGstNumber(gstNumbers[0])
        }
      }
      else{
        setAllGst([client?.gstNo])
      }
    }
    }).catch((err)=>{
      console.log(err)
    })
  }

  useEffect(()=>{
    if(gstRecords && gstRecords?.length){
      const gstData = gstRecords[0];
      if(gstData?._id){
        const {cId,gstNo,amt} = gstData;
          if(cId){
            getCompanyByID(cId)
          }
          if(gstNo && !gstNumber){
            setGstNumber(gstNo)
          }
          if(clientValue?.value && cId && clientValue?.value !== cId){
            setGstNumber(gstNumber)
            getCompanyByID(clientValue?.value)

          }
          if(!amt){
            setGstAmount(amt)
          }
      }
      else{
        if(clientValue && clientValue?.value){
          getCompanyByID(clientValue?.value)
        }
      } 
    }
    else{
        getCompanyByID(clientValue?.value)
    }
  },[gstRecords,clientValue])

  useEffect(() => {
    dispatch(fetchAsyncGetOrganization())
  }, []);
  useEffect(()=>{
    if(gstNumber && organizationList?.length){
      const stateCode = gstNumber?.substring(0, 2);
      const gstCode = organizationList[0]?.gstNo;
      const organizationStateCode = gstCode?.substring(0, 2);
      if(stateCode === organizationStateCode){
        setGstType('SGST')
      }
      else{
        setGstType('IGST')
      }
    }
    else{
      setGstType('IGST')
    }
  },[gstNumber,organizationList])


  const handleUpdateListItem = (item)=>{
    handleUpdateList(item,editListItemIndex)
    handleCloseAddItem();    
  }
 
  const getSalesItemByClient = async()=>{
    const data = {
      clientId:clientValue?.value,
      currency:currency?.code || "INR"
    }
    await dispatch(fetchAsyncGetSalesItemByClient(data)).then((res)=>{
    if(res?.payload){
      const items = res?.payload?.items;
      setItemListData(items)
    }
    }).catch((err)=>{
      console.log(err)
    })
  }
  useEffect(()=>{
    if(currency && clientValue?.value && isMenuOpen){
      getSalesItemByClient();
    }
  },[currency,clientValue,isMenuOpen])
    

    const handleItemSearch = (e) => {
      const value = e?.target?.value;
      if (!value) {
        getSalesItemByClient()      
      }
      else{
        const filterData = itemListData.filter(
          (option) =>
            option.name.toLowerCase().indexOf(value.toLowerCase()) >= 0
        );
        setItemListData(filterData)

      }
  
    }; 
    const [openExportMenu,setOpenExportMenu] = useState(false)
    const [isProforma,setIsProforma] = useState(false)

    const handleOpenMenu = () => {
      setOpenMenu(true);
    };
    
    return (
      <>
        <Box className="item-table-label">
          <span className="lable-text">Item Table</span>

          {editData?._id && (
            <div className="item-export-menu add-new-btn">
              <Menu>
                <MenuButton
                  onClick={handleOpenMenu}
                  title="Export"
                  className="new-btn add-new-menu-btn"
                >
                  <Box display="flex">
                    <PiExportBold fontSize={18} />
                  </Box>
                </MenuButton>
                {openMenu && (
                  <MenuList className="menu-list">
                    <MenuItem
                      className={`menu-item`}
                      isDisabled={!editData?.isInv}
                      onClick={() => setOpenExportMenu(!openExportMenu)}
                    >
                      Tax Invoice
                    </MenuItem>
                    <MenuItem
                      className={`menu-item`}
                      isDisabled={!editData?.isPfi}
                      onClick={() => {
                        setOpenExportMenu(!openExportMenu);
                        setIsProforma(true);
                      }}
                    >
                      Proforma Invoice
                    </MenuItem>
                  </MenuList>
                )}
              </Menu>
            </div>
          )}
        </Box>
        <div className="ember-view">
          <Table className="line-item-table line-item-table-light">
            <Thead className="line-item-header bill-items">
              <Tr>
                <Th className="line-item-column over-flow col-number">No.</Th>
                <Th className="line-item-column over-flow bill-desc-us item-details-cell">
                  Item Details
                </Th>
                <Th className="line-item-column over-flow text-end item-qty">
                  Quantity
                </Th>
                <Th className="line-item-column text-end item-rate">Rate</Th>
                <Th className="line-item-column text-end item-tax">Tax</Th>

                <Th className="line-item-column  text-end item-amount-us">
                  Amount
                </Th>
                <Th className=""></Th>
              </Tr>
            </Thead>
            <Tbody className="ember-view line-item-body">
              {itemData && itemData?.length
                ? itemData?.map((item, i) => {
                    return (
                      <Tr className="ember-view line-item bill-items new-line-item">
                        <Td className="ember-view line-item-column item-details col-number">
                          <Text className="item-number">{i + 1}</Text>
                        </Td>
                        <Td className="ember-view line-item-column item-details bill-desc-us item-details-cell">
                          {item?.slItm?._id ? (
                            <Box className="item-content ">
                              <div className="name">
                                <Box display="flex" justifyContent="space-between">
                                  <Text className="label label-2">
                                    {item?.slItm?.name}
                                  </Text>

                                  <div className="item-name-actions-container">
                                    <div className="item-actions item-actions-2">
                                      <div
                                        className={`icon-btn`}
                                        onClick={() =>
                                          handleEditListItem(item?.slItm, i)
                                        }
                                      >
                                        <FaPen size={14} className="icon" />
                                      </div>
                                      <div
                                        className={`icon-btn`}
                                        onClick={() =>
                                          handleRemoveSelectedItem(i)
                                        }
                                      >
                                        <IoIosClose
                                          size={16}
                                          className="iconclose"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Box>
                                {/* <Text className="sku-id">
                                  SKU :{" "}
                                  {item?.slItm?.typ === "goods"
                                    ? item?.slItm?.hCd
                                    : item?.slItm?.sCd}
                                </Text> */}
                              </div>
                              <TextAreaField
                                customClass={`ember-text-area form-control content-description item-description ember-view}`}
                                name="description"
                                value={item?.slItm?.dc}
                                handleChange={(e) =>
                                  handleUpdateItemField(
                                    e.target.value,
                                    "description",
                                    i
                                  )
                                }
                                placeholder="Add a description to your item"
                              />
                              <div className="item-tratment">
                                <Text className="type ">
                                  {item?.slItm?.typ}
                                </Text>
                                <Text display="flex" className="itemcode">
                                  {item?.slItm?.typ === "goods" ? "HSN" : "SAC"}{" "}
                                  Code:
                                  <span className="hsnvalue">
                                    {item?.slItm?.typ === "goods"
                                      ? item?.slItm?.hCd
                                      : item?.slItm?.sCd}{" "}
                                  </span>
                                  <Box className="icon-btn mt-1 mx-2 hsnvalue">
                                    <ItemCodePopover
                                      type={item?.slItm?.typ}
                                      value={
                                        item?.slItm?.typ === "goods"
                                          ? item?.slItm?.hCd
                                          : item?.slItm?.sCd
                                      }
                                      handleSave={(value, name) =>
                                        handleUpdateItemField(value, name, i)
                                      }
                                    />
                                  </Box>
                                </Text>
                              </div>
                            </Box>
                          ) : (
                            <TextAreaField
                              customClass="ember-text-area form-control item-description ember-view"
                              placeholder="Type or click to select an item."
                              name="remarks"
                              onFocus={() => handleFocus(i)}
                              handleChange={(e) => handleItemSearch(e)}
                            />
                          )}

                          {isMenuOpen && menuIndex === i && (
                            <Box className="item-menu-popup">
                              {!itemListData && !itemListData?.length ? (
                                <Text className="no-result">
                                  No Results Found. Try a diffrent Keyword.{" "}
                                </Text>
                              ) : (
                                <Box className="menu-item-list">
                                  <Box
                                    float="right"
                                    onClick={() => handleBlur()}
                                    cursor="pointer"
                                  >
                                    <IoCloseCircleOutline
                                      size={20}
                                      color="red"
                                      border={1}
                                    />
                                  </Box>
                                  <List mt={5}>
                                    {itemListData &&
                                      itemListData?.map((data, index) => {
                                        return (
                                          <ListItem
                                            className="list-item"
                                            id={index}
                                            onClick={() => {
                                              handleListItem(data, i);
                                              handleBlur();
                                            }}
                                          >
                                            <Text className={`label label-2`}>
                                              {data?.name}
                                            </Text>
                                            <p className={`helper`}>
                                              SKU: {data?.sCd || data?.hCd} &nbsp;&nbsp;Purchase Rate: {currency?.symbol || '₹'}
                                              {formatAmountIndianRupees(
                                                data?.prc
                                              )}
                                            </p>
                                          </ListItem>
                                        );
                                      })}
                                  </List>
                                </Box>
                              )}
                              <Box className="add-new-item-btn mt-3">
                                <Button
                                  className="btn mx-0"
                                  onClick={() => {
                                    handleOpenAddItem();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-item-icon"
                                    size={16}
                                  />
                                  <Text className="btn-text mx-2">
                                    Add New Item
                                  </Text>
                                </Button>
                              </Box>
                            </Box>
                          )}
                        </Td>
                        <Td className="ember-view line-item-column item-qty">
                          <InputFormControl
                            type="number"
                            value={item?.qty || ""}
                            name="quantity"
                            disabled={!item?.slItm?._id}
                            customClass="ember-text-field text-end ember-view"
                            handleChange={(e) =>
                              handleUpdateItemField(
                                e?.target?.value,
                                "quantity",
                                i
                              )
                            }
                          />

                          <Text className="text-end mx-2" fontSize={12}>
                            {item?.slItm?.unt?.value}
                          </Text>
                        </Td>
                        <Td className="ember-view line-item-column item-rate">
                          <CurrencyFormat
                            customInput={Form.Control}
                            className={`ember-text-field text-end ember-view form-control `}
                            type="text"
                            name="rate"
                            disabled={!item?.slItm?._id}
                            value={item?.prc || ""}
                            placeholder=""
                            thousandSeparator={true}
                            // prefix={"$"}
                            onValueChange={(e) =>
                              handleUpdateItemField(e?.value, "rate", i)
                            }
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </Td>
                        <Td className="ember-view line-item-column item-tax select-tax-options">
                          <VendorCustomSelect
                            options={taxOptions}
                            placeHolder="Select a tax"
                            defaultValue={item?.tax}
                            isDisabled={
                              !item?.slItm?._id || currency?.code !== "INR"
                            }
                            isSearchable
                            onChange={(newValue) =>
                              handleUpdateItemField(newValue, "tax", i)
                            }
                          />
                        </Td>
                        <Td className="ember-view line-item-column text-end item-amount-us">
                          {Number(item?.amt || 0).toFixed(2)}
                          <div className="item-actions-container">
                            <div className="item-actions">
                              <div className=" ellipsis-btn no-caret  text-blue">
                                <FaEllipsisVertical />
                              </div>
                              <div
                                className={`item-close-btn icon-button action}`}
                                onClick={(e) => handleDeleteRow(e, i)}
                              >
                                <IoIosClose size={28} />
                              </div>
                            </div>
                          </div>
                        </Td>
                      </Tr>
                    );
                  })
                : null}
            </Tbody>
          </Table>
          <Row>
            <Col className="col-lg-3">
              <Box display="flex" alignItems="center" className=" add-item-btn">
                <Button
                  className={`btn mt-2 mx-0}`}
                  onClick={() => handleAddRow()}
                >
                  <FaPlusCircle className="add-item-icon" size={16} />
                  <Text className="btn-text">Add New Row</Text>
                </Button>
              </Box>
            </Col>

            <Col>
              <Box className="invoice-discount ms-auto col-lg-9 px-0 mt-5 me-4">
                <div className="total-section rounded-xlg px-4 py-3 total-section-bg">
                  <Box display="flex" justifyContent="space-between" className=" sub-total text-semibold ">
                    <div className="total-label">
                      Sub Total <br />
                      <div className="font-xxs">
                        Total Quantity : {total?.qty || 0}
                      </div>
                    </div>
                    <div className="total-amount text-semibold">
                      <span></span>
                      {formatAmountIndianRupees(total?.amt || 0)}{" "}
                      {currency?.symbol || "₹"}
                    </div>
                  </Box>
                  <div className="total-row gst-number-row sub-total text-semibold ">
                    <div className="total-label">
                      GST Number <br />
                    </div>
                    <div className="total-amount text-semibold">
                      <Box>
                        <Form.Select
                          className="custom--dropdown-container"
                          value={gstNumber}
                          disabled={!clientValue?.value}
                          onChange={(e) => {
                            setGstNumber(e.target.value);
                          }}
                        >
                          <option value="">Select GST Number</option>
                          {allGst &&
                            allGst?.length > 0 &&
                            allGst?.map((gst) => {
                              return <option value={gst}>{gst}</option>;
                            })}
                        </Form.Select>
                      </Box>
                    </div>
                  </div>
                  {currency?.code === "INR" && (
                    <>
                      {gstType === "IGST" ? (
                        <>
                            <Box display="flex" width="100%" justifyContent="space-between">
                                  <div className="mt-3 ">
                                    <label for="IGST" className="mx-1 gst-label">
                                      IGST
                                    </label>
                                  </div>
                            <div className="mt-3">
                              {formatAmountIndianRupees(gstAmount?.i || 0)}{" "}
                              {currency?.symbol || "₹"}
                            </div>
                              </Box>
                        </>
                      ) : (
                        <>
                           <Box display="flex" width="100%" justifyContent="space-between">
                                  <div className="mt-3 ">
                                    <label for="CGST" className="mx-1 gst-label">
                                      CGST
                                    </label>
                                  </div>
                            <div className="mt-3">
                              {formatAmountIndianRupees(gstAmount?.c || 0)}{" "}
                              {currency?.symbol || "₹"}
                            </div>
                              </Box>
                              <Box display="flex" width="100%" justifyContent="space-between">
                                  <div className="mt-3 ">
                                    <label for="SGST" className="mx-1 gst-label">
                                      SGST
                                    </label>
                                  </div>
                            <div className="mt-3">
                              {formatAmountIndianRupees(gstAmount?.s || 0)}{" "}
                              {currency?.symbol || "₹"}
                            </div>
                              </Box>
                        </>
                      )}
                    </>
                  )}
                    <div className="total-row mx-2">
                      <div className="row">
                        <CheckboxField
                          customClass="mx-2"
                          isChecked={isFright}
                          handleChange={handleIsFright}
                          label="Is Freight Charges"
                        />
                      </div>
                      </div>
                      {isFright &&
                  <div className="total-row">
                    <div className="total-label">
                      <div className="row">
                        <div className="col-lg-5">
                          <div className="">Freight Charges</div>
                        </div>
                        <div className="col-lg-7">
                          <div className="input-group">
                            <AmountInputField
                              customClass="ember-text-field text-end ember-view"
                              symbol={currency?.symbol}
                              name="shippingCharge"
                              value={shippingCharge || ""}
                              handleChange={(value) => {
                                handleShippingCharge(value);
                              }}
                              InputGroupText={
                                <div className="mx-1 mt-2">
                                <CustomPopover popoverText="Amount spent on shipping the goods." />
                              </div>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="total-amount mt-3">
                      {formatAmountIndianRupees(shippingCharge || 0)}{" "}
                      {currency?.symbol || "₹"}
                    </div>
                  </div>
                      }
                  <div className="total-row">
                    <div className="total-label">
                      <div className="row">
                        <div className="col-lg-5">
                          <div className="input-group adjusment-div">
                            <InputFormControl
                             customClass="ember-text-field  ember-view form-control"
                             type="text"
                             value={adjustmentLabel}
                             handleChange={handleAdjustmentLabel}
                            />
                          </div>
                        </div>
                        <div className="col-lg-7">
                          <div className="input-group">
                            <AmountInputField
                              customClass="ember-text-field text-end ember-view"
                              symbol={currency?.symbol}
                              name="adjusmentAmount"
                              value={adjustmentAmount || ""}
                              handleChange={(value) => {
                                handleAdjustmentAmount(value);
                              }}
                              InputGroupText={
                                <div className="mx-1 mt-2">
                                <CustomPopover popoverText="Add any other +ve or -ve charges that need to be applied to adjust the total amount of the transaction Eg. + 10 or -10." />
                                </div>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="total-amount mt-3">
                      {formatAmountIndianRupees(adjustmentAmount || 0)}{" "}
                      {currency?.symbol || "₹"}
                    </div>
                  </div>
                  <Box display="flex" justifyContent="space-between" className="text-semibold mt-3 pt-2  border-top">
                    <div className="total-label" style={{ fontSize: "15px" }}>
                      Total ({currency?.symbol || "₹"})
                    </div>
                    <div className="total-amount" style={{ fontSize: "15px" }}>
                      {formatAmountIndianRupees(totalPaymentAmount)}{" "}
                      {currency?.symbol || "₹"}
                    </div>
                  </Box>
                </div>
              </Box>
            </Col>
          </Row>
        </div>
        {openAddItem && (
          <AddSalesItemForm
            isOpen={openAddItem}
            closeModal={() => {
              handleCloseAddItem();
            }}
            isEdit={openlistEditModal}
            editData={editListItem}
            updateListItem={(item) => handleUpdateListItem(item)}
            listItemBtn={true}
            isDataLoading={isSalesItemDataLoading}
          />
        )}
        {openExportMenu && (
          <SalesInvoicePdf
            isOpen={openExportMenu}
            onClose={() => {
              setOpenExportMenu(!openExportMenu);
              setIsProforma(false);
            }}
            isProforma={isProforma}
            expenseData={editData}
            itemList={itemData}
            moduleId={moduleId}
          />
        )}
      </>
    );
}

export default AddItemComponent;